import { render, staticRenderFns } from "./_article.vue?vue&type=template&id=68933399"
import script from "./_article.vue?vue&type=script&lang=js"
export * from "./_article.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports